import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, AfterViewInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-addallowancepopup',
  templateUrl: './addallowancepopup.component.html',
  styleUrls: ['./addallowancepopup.component.css']
})
export class AddallowancepopupComponent implements OnInit {

  @ViewChildren('input') firstipcontrol;


  formname: String = "Allowance";
  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  istds: boolean = false;
  ispf: boolean = false;
  isesi: boolean = false;
  isprofessionaltax: boolean= false;


  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  allowanceColl: any = [];
  allowanceBO: any = {};
  allowanceid: number = 0
  settingsColl: any = [];

  allowanceform = new FormGroup({
    allowanceid: new FormControl(0),
    allowancename: new FormControl('', Validators.required),
    isesi: new FormControl(false),
    ispf: new FormControl(false),
    isprofessionaltax: new FormControl(false),
    istds: new FormControl(false),
    inactive: new FormControl(false),
  });

 @Output() emitData = new EventEmitter();


  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private activeModal: NgbActiveModal,) {

    this.fnServiceChanges();
  }
    


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.allowanceform.reset();
      this.fnInitializeFormGroup();
      this.fngetSettings();
    
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.allowanceid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  ngAfterViewInit() {
    //this.firstipcontrol.first.nativeElement.focus();
  }
  fnInitializeFormGroup() {
    this.allowanceform.setValue({
      allowanceid: 0,
      allowancename: '',
      isesi: false,
      ispf:false ,
      isprofessionaltax: false,
      istds: false,
      inactive: false
    })
  }

  fngetSettings() {   
    var data = {
        'settingsid':0,
        'companyid': this.loginService.fnGetCompanyId(),                                                                       
    }
    this.appService.getSettings(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){
            this.settingsColl=res.json().result[1];  
           for(let row of this.settingsColl){
            
            
              if(row.settingsname === 'ENABLE ESI' && row.settingsvalue ==='1'){
                
                this.isesi=true;
              
              }
              if(row.settingsname === 'ENABLE TDS' && row.settingsvalue ==='1'){
                
                this.istds=true;
              
              }
              if(row.settingsname === 'ENABLE PF' && row.settingsvalue ==='1'){
                
                this.ispf=true;
              
              }
              if(row.settingsname === 'ENABLE PROFESSIONAL TAX' && row.settingsvalue ==='1'){
                
                this.isprofessionaltax=true;
              
              }
           }
                         }                 
         else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{          
            this.toastr.error('Error', err);
    })
  }

  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;        
    }
    
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.allowanceform.valid) {
        //Check
        this.saveloading = true;

        var data = {
          'allowanceid': this.allowanceid,
          'allowancename': this.allowanceform.get('allowancename').value,
          'inactive': this.allowanceform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckAllowance(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
               
           
                  //Insert 
                  this.fnInsertAllowance(data);
     
              }
              else {
                if (_checkresult === "name") {
                  this.saveloading = false;

                  this.allowanceform.controls['allowancename'].setErrors({ 'notfound': true });
                }
              }
            }
            else {
              this.saveloading = false;

              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertAllowance(data) {

    this.appService.fnInsertAllowance(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {

           
            console.log( res.json())
            this.toastr.success('', "The new Allowance has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.allowancename);
            var result = res.json().result;
            
            var allowanceid = 0;
            if (result.length > 0) {
              allowanceid = result[0].allowanceid
            }
            this.emitData.emit(allowanceid);
            this.activeModal.close(true);
  

          }  
          else {
            this.loginService.fnAPIError(res.json())
          }
        }
        (err) => {
          this.saveloading = false;        
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch{

    }
  }
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }


}


 